import React from 'react';
import PropTypes from 'prop-types';

/**
 * SVG icon is added inline just for a test, if test succeeds it should be moved to dibs-vg.
 */
export const NegotiableIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 212.58">
        <path
            d="M87.12,76.38h157.5v105H203.56V219l-39.15-37.57H87.12V135.13l.13-.13h-.13Zm-82-52h157.5V71H81.73v61.83L46.17,167V129.38H5.12ZM0,19V134.77H40.79v44.81l40.94-39.29v46.48h80.51l46.7,44.81V186.77H250V71H168V19Z"
            transform="translate(0 -19)"
        />
    </svg>
);

NegotiableIcon.propTypes = {
    className: PropTypes.string.isRequired,
};
